import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from "react-router-dom";

import { query, where, collection, getDocs, doc, getDoc } from "firebase/firestore";
import { db } from "../firebase.js";
import Cookies from "js-cookie";
import { Helmet } from "react-helmet";
import './installation.css';
import { Toast } from '../components_root/ToastContext.jsx';
import { MdCalculate, MdCall, MdCode, MdEditDocument, MdFace, MdKey, MdKeyboard, MdLocationCity, MdOutlinePhoneAndroid, MdPhoneAndroid, MdPictureAsPdf, MdQrCode } from "react-icons/md";
import { Create_services } from './create_services.js';
import { Randomcode } from '../components_root/rendom_code.js';
import { Verify_services_status } from './verify_services_status.js';
export const seo = {
    title: "aooz Services | Free & Premium Online Tools for Productivity, SEO & File Conversion",
    description: "Discover aooz's free and premium online services including word counter, image to PDF, favicon generator, SEO analyzers, text utilities, and more. Enhance productivity with powerful tools for students, writers, developers, and businesses.",
    keywords: "aooz services, free online tools, premium tools, seo tools, text utilities, file converters, image to pdf, favicon generator, word counter, productivity tools, online converters",
    url: "https://aooz.in/services",
    image: "https://aooz.in/assets/logo.png"
};
export default function Accounting_finance_services() {
    const { Toastshow } = Toast();
    const navigate = useNavigate();
    const [companydata, setCompanydata] = useState([]);
    const [servicesdata, setServicesdata] = useState([]);
    const aooz_company_uid = "VSztsKaIU4z2l5rIRY3ZTvBhIM";
    const [serviceid, setServiceId] = useState("NMkgRL8tU2XxbpCfzyHA");
    const servicetablename = "websiteservicesdb";
      const [eorrdata, setEorrdata] = useState();

    useEffect(() => {
        const select_company_uid = Cookies.get("select_company_uid");
        if (!select_company_uid) return;
        if (select_company_uid == aooz_company_uid) {
            return;
        }
        const fetchCompany = async () => {
            const docRef = doc(db, "companies", select_company_uid);
            const docSnap = await getDoc(docRef);

            if (docSnap.exists()) {
                const companyData = {
                    id: docSnap.id,
                    ...docSnap.data(),
                };

                setCompanydata([companyData]); // store as array for map()
            } else {
                setCompanydata([]);
            }
        };

        fetchCompany();
    }, []);
    //Verify_services_status
    const [services_status, setServices_status] = useState(false);
    const [services_statusdata, setServices_statusdata] = useState([]);
useEffect(() => {
    const verifyStaffAccount = async () => {
        try {
            const result = await Verify_services_status("websiteservicesdb");
 
            if (!result || result.success !== true) {
                // failure case
                setServices_statusdata(result?.data || null);
                setServices_status(true);
                return;
            }

            // success case
            setServices_statusdata(result.data);
            setServices_status(true);
            navigate("/" + result.data.slug);

        } catch (e) {
            setServices_status(true);
            setEorrdata("Verify Error:", e);
        }
    };

    verifyStaffAccount();
}, []);


    useEffect(() => {
        const fetchVoucher = async () => {
            const select_company_uid = Cookies.get("select_company_uid");
            if (!select_company_uid) return;

            // Get only THIS service by ID
            const docRef = doc(db, "servicesdb", serviceid);
            const docSnap = await getDoc(docRef);

            if (!docSnap.exists()) return;

            const serviceId = docSnap.id;
            const serviceData = docSnap.data();

            // Match with company-specific services
            const q = query(
                collection(db, "companies", select_company_uid, "websiteservicesdb"),
                where("suid", "==", serviceId)
            );

            const companySnap = await getDocs(q);

            const companyServices = companySnap.docs.map(c => ({
                id: c.id,
                ...c.data()
            }));

            // Set final data format expected by your UI
            setServicesdata([
                {
                    id: serviceId,
                    ...serviceData,
                    companyServices: companyServices
                }
            ]);
        };

        fetchVoucher();
    }, []);

    const Create_services_handle = async () => {
        const select_company_uid = Cookies.get("select_company_uid");
        if (!select_company_uid) return;

        const data = {
            servicetablename,
            companyuid: select_company_uid,
            title: servicesdata[0].title,
            description: servicesdata[0].description,
            serviceid,
            serviceid,
            ...servicesdata[0],
            banner_url: "https://firebasestorage.googleapis.com/v0/b/aoozpayment.firebasestorage.app/o/services_icon%2Fsite_design.jpg?alt=media&token=8df269d3-5a6e-4c66-972a-95a7746547d3",
        };

        const result = await Create_services(data);
        if (result.success) {
            navigate(`/${servicesdata[0].slug}`);
            Toastshow("Service created successfully");
        } else {
            Toastshow(`Error: ${result.error}`);
        }
    };

    return (
        <div>

            <Helmet>
                <title>{seo.title}</title>
                <meta name="description" content={seo.description} />
                <meta name="keywords" content={seo.keywords} />
                <meta property="og:title" content={seo.title} />
                <meta property="og:description" content={seo.description} />
                <meta property="og:image" content={seo.image} />
                <meta property="og:url" content={seo.url} />
            </Helmet>

            <div className="container_roots">
                <div className="container_size p-3">
                    {companydata?.receipt_title}
                    <div className='service_body'>
                        {companydata.length > 0 ? (
                            companydata.map((row) => (
                                <div className='b-bottom'>
                                    <table key={row.id}>
                                        <tbody>
                                            <tr>
                                                <td width={90}>
                                                    <img src={row.logo_url} className="service_photo" />
                                                </td>
                                                <td>
                                                    <table>
                                                        <tr>

                                                            <td>
                                                                <div className="text-hero-sub fcap bold blue text-pre">
                                                                    {row.company}
                                                                </div>
                                                            </td>
                                                        </tr>

                                                        <tr>

                                                            <td>
                                                                <div className="text-h1 bold cap text-pre test-off">
                                                                    {row.brandname || "No domain registered"}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr>

                                                            <td>
                                                                <div className="text-h2 text-pre test-off">
                                                                    {row.domain_registration || "No domain registered"}
                                                                </div>
                                                            </td>
                                                        </tr>

                                                    </table>
                                                </td>

                                            </tr>

                                        </tbody>
                                    </table>
                                </div>
                            ))
                        ) : (
                            <div
                                className="button-ui text-h2 bold fcap p-22 cursor"
                                onClick={() => navigate("/create-company")}
                            >
                                Create company</div>
                        )}
                        {/* Display services */}
<div className='red text-h2'>{eorrdata}</div>
                        {servicesdata.length > 0 && servicesdata.map((row) => (
                            <div key={row.id} className=" ui-items items-back">
                                <table>
                                    <tr><td> <img src={row.logo_url} className="service_photo" /></td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="text-hero-sub bold text-pre"   >{row.name}</div>
                                        </td>
                                    </tr>
                                    <tr>

                                        <td>
                                            <div className="text-h2 text-pre test-off"  >{row.description}</div>
                                        </td>
                                    </tr>
                                </table>
                                <div className='service_price_body items-back-fill rounded p-2'>
                                    <table >
                                        <tr>
                                            <td width={60}>
                                                <div className="text-h2 fcap" >Price</div>
                                            </td>
                                            <td>
                                                <div className="text-h1 bold fcap" >₹{row.price}/-</div>

                                            </td>
                                        </tr>
                                        <tr>
                                            <td width={130}>
                                                <div className="text-h2 fcap" >Stories</div>
                                            </td>
                                            <td>
                                                <div className="text-h1 fcap" >₹{row.stories_rant} MB</div>

                                            </td>
                                        </tr>

                                        <tr>
                                            <td width={130}>
                                                <div className="text-h2 fcap" >Stories </div>
                                            </td>
                                            <td>
                                                <div className="text-h1 fcap" >₹{row.stories_mb} MB</div>

                                            </td>
                                        </tr>

                                        <tr>
                                            <td width={130}>
                                                <div className="text-h2 fcap" >Stories Topup</div>
                                            </td>
                                            <td>
                                                <div className="text-h1 bold fcap" >₹{row.stories_rate}/-</div>

                                            </td>
                                        </tr>

                                        <tr>
                                            <td width={130}>
                                                <div className="text-h2 fcap" >Validity day</div>
                                            </td>
                                            <td>
                                                <div className="text-h1 bold fcap" >₹{row.validity_day}/-</div>

                                            </td>
                                        </tr>
                                        <tr>
                                            <td width={130}>
                                                <div className="text-h2 fcap" >Tax (GST)</div>
                                            </td>
                                            <td>
                                                <div className="text-h1 bold fcap" >₹{row.tax_rate}%</div>

                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <br />

                                {row.companyServices.length > 0 ? (
                                    row.companyServices.map((compService) => (
                                        <div key={compService.id} className='button-ui2 text-h2 bold fcap p-22 cursor' onClick={() => navigate(`/${row.slug}`)}>Open</div>
                                    ))
                                ) : (
                                    <div onClick={() => Create_services_handle()} className='button-ui text-h1 bold fcap p-22 cursor'>Start Installation </div>
                                )}
                                <br />
                                <div className="text-h3 text-pre test-off" >{row.about}</div>
                            </div>
                        ))}


                    </div>

                </div>

            </div >



        </div >
    );
}
